// Keeps "Subscribe & save" on Add to bag clicks made while a scent change is still loading.
// Horizon queues those clicks and its queued add posts only the variant and quantity, dropping
// the selling plan. While a plan is selected and a change is in flight, hold the submit and
// re-submit once the change settles, so Horizon's normal (form-based) add carries the plan.
let pendingChange = null;

document.addEventListener(
  'shopify:product:select',
  (event) => {
    const change = Promise.resolve(event.promise).catch(() => {});
    pendingChange = change;
    change.finally(() => {
      if (pendingChange === change) pendingChange = null;
    });
  },
  true
);

// window capture runs before Horizon's own submit delegation (document, capture phase)
window.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !pendingChange) return;
    // form.id is shadowed by the form's own <input name="id">, so read the attribute
    const formId = form.getAttribute('id') || '';
    if (!formId.startsWith('BuyButtons-ProductForm-')) return;
    const plan = document.querySelector(`input[name="selling_plan"][form="${formId}"]:checked`);
    if (!plan || plan.value === '' || plan.value === '0') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const { submitter } = event;
    pendingChange
      .then(() => new Promise((resolve) => setTimeout(resolve, 50)))
      .then(() => {
        try {
          form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
        } catch {
          form.requestSubmit();
        }
      });
  },
  true
);
